import React from 'react';
import { FormikProps } from 'formik';
import { CloseButton } from '@withjoy/joykit';
import { Redirect, Route, Switch, RoutePath, RoutesProvider, useRouterHelper, useHistory } from '@shared/core';
import { ErrorSplash } from '@shared/components';
import { Form, Address } from '@apps/contactCollector/guest/routes';
import { useUpdateController } from './Update.controller';
import { Contacts } from '@apps/guestList/GuestList.types';

interface UpdateProps {
  eventId: string;
  eventHandle: string;
  firebaseEventId: string;
  contactId: string;
}

const updateRoutePaths = {
  form: {
    path: 'form',
    goToPath: () => 'form'
  },
  address: {
    path: 'address',
    goToPath: () => 'address'
  }
};

const RoutesUpdate: React.FC<{
  formik: FormikProps<Contacts>;
  isMutationLoading: boolean;
  e164PhoneNumber: { [key: number]: string };
  setE164PhoneNumber: React.Dispatch<React.SetStateAction<{ [key: number]: string }>>;
}> = ({ formik, isMutationLoading, e164PhoneNumber, setE164PhoneNumber }) => {
  const routeHelpers = useRouterHelper();

  const routes: Array<RoutePath<{}>> = [
    {
      path: routeHelpers.buildPath(updateRoutePaths.form.path),
      component: () => (
        <Form
          formik={formik}
          isCollectHouseholdEnabled={false}
          isIframeVersion
          isMutationLoading={isMutationLoading || !formik.dirty}
          e164PhoneNumber={e164PhoneNumber}
          setE164PhoneNumber={setE164PhoneNumber}
          hideTermsAndConditions
          formatIntlTelInputOnInit={false}
          isMobileGuesList
        />
      )
    },
    {
      path: routeHelpers.buildPath(updateRoutePaths.address.path),
      component: () => <Address formik={formik} isIframeVersion isMutationLoading={isMutationLoading} />
    }
  ];

  return (
    <Switch>
      {routes.map(route => (
        <Route key={route.path} path={route.path} render={route.component} exact />
      ))}
      <Redirect to={routes[0].path} />
    </Switch>
  );
};

const Update: React.FC<UpdateProps> = ({ eventId, eventHandle, firebaseEventId, contactId }) => {
  const history = useHistory();
  const { tAdmin, showErrorPage, isLoading, formik, isMutationLoading, e164PhoneNumber, setE164PhoneNumber } = useUpdateController(
    eventId,
    eventHandle,
    firebaseEventId,
    contactId
  );

  if (isLoading) {
    return null;
  }

  if (showErrorPage) return <ErrorSplash customError={{ title: tAdmin.errorPageTitle(), subtitle: tAdmin.errorPageSubTitle() }} />;

  return (
    <RoutesProvider appUrl="guestlist/update/:contactId" handle={eventHandle}>
      <CloseButton paddingX={0} position="fixed" top={0} right={0} zIndex={100} onClick={() => history.push(`/${eventHandle}/edit/guestlist`)} />
      <RoutesUpdate formik={formik} isMutationLoading={isMutationLoading} e164PhoneNumber={e164PhoneNumber} setE164PhoneNumber={setE164PhoneNumber} />
    </RoutesProvider>
  );
};

export default Update;
